import { navigate } from '@reach/router';
import { post } from '~lib/apiClient';
import { getLocalToken, persistLocalToken, clearLocalToken, getTokenPayload } from '~util/token';

// function getUser() {
//   const token = getToken();
//   if (!token) {
//     return Promise.resolve(null);
//   }
//   return get('me').catch(error => {
//     logout();
//     return Promise.reject(error);
//   });
// }

function login({ username, password }) {
  return post('/authenticate', { username, password }).then(data => {
    if (!data || data.httpStatus === 403 || !data.access_token) {
      throw new Error('Invalid credentials, please try again');
    }
    persistLocalToken(data.access_token);
    return data.access_token;
  });
}

function logout() {
  navigate('/');
  clearLocalToken();
}

function getUser() {
  const token = getLocalToken();
  if (!token) {
    return null;
  }
  const payload = getTokenPayload(token);
  return {
    id: payload.sub,
    username: payload['https://netconnapi.gogoair.com/username'],
    email: payload['https://netconnapi.gogoair.com/email'],
  };
}

export { login, logout, getUser };
